import React from 'react'

import { Button, Col, Row, Portlet } from '_zari/core'

import { CodigosTransaccionesConstant, TiposTablaPersonalizadaConstant } from 'constants/index'

const portletBreadcrumbs = [{ name: 'Tablas Personalizadas' }]

const TablasMaestrasPage = ({ history }) => {
  return (
    <>
      <Portlet>
        <Portlet.Header title='Tablas Personalizadas' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <Row>
            {TiposTablaPersonalizadaConstant.__array.map((x, k) => (
              <Col key={k} md={3} className='mt-2'>
                <Button
                  block
                  onClick={() =>
                    history.push(
                      `${CodigosTransaccionesConstant.TABLASPERSONALIZADAS_UNICO}/${x.id}`
                    )
                  }
                >
                  {x.nombre}
                </Button>
              </Col>
            ))}
          </Row>
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default TablasMaestrasPage
